import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import { pdfStyles } from '../styles/pdf-styles';
import { convertImageUrlForPDF } from '../utils/convert-image-url-for-pdf';

interface PDFHeaderProps {
  organizationName: string;
  organizationAddress?: string;
  organizationCity?: string;
  organizationZipCode?: string;
  organizationSiret?: string;
  organizationNumCertification?: string;
  organizationLogo?: string | null;
  user?: {
    prenom?: string;
    nom?: string;
  };
  logoSize?: 'default' | 'small';
  marginBottom?: number;
  /** Modèle de fiche : masquer le logo ou le bloc organisation. */
  showLogo?: boolean;
  showOrganisation?: boolean;
}

/**
 * Reusable PDF header component with logo and organization information
 */
export const PDFHeader: React.FC<PDFHeaderProps> = ({
  organizationName,
  organizationAddress,
  organizationCity,
  organizationZipCode,
  organizationSiret,
  organizationNumCertification,
  organizationLogo,
  user,
  logoSize = 'default',
  marginBottom = 5,
  showLogo = true,
  showOrganisation = true,
}) => {
  const logoStyle = logoSize === 'small' ? pdfStyles.logoSmall : pdfStyles.logo;
  const headerInfoStyle = logoSize === 'small' ? pdfStyles.headerInfo : pdfStyles.headerInfoNoMargin;

  return (
    <View style={[pdfStyles.header, { marginBottom }]}>
      {!showLogo ? null : organizationLogo ? (
        <Image src={convertImageUrlForPDF(organizationLogo)} style={logoStyle} />
      ) : (
        <View style={pdfStyles.logoPlaceholder}>
          <Text style={{ fontSize: 8, color: '#9ca3af' }}>Logo</Text>
        </View>
      )}
      <View style={headerInfoStyle}>
        {showOrganisation && <Text style={pdfStyles.headerTitle}>{organizationName}</Text>}
        {showOrganisation && organizationAddress && (
          <Text style={pdfStyles.headerText}>{organizationAddress}</Text>
        )}
        {showOrganisation && (organizationZipCode || organizationCity) && (
          <Text style={pdfStyles.headerText}>
            {organizationZipCode || ''} {organizationCity || ''}
          </Text>
        )}
        {organizationSiret && (
          <Text style={pdfStyles.headerText}>
            <Text style={pdfStyles.headerTextBold}>SIRET :</Text> {organizationSiret}
          </Text>
        )}
        {user && (user.prenom || user.nom) && (
          <Text style={[pdfStyles.headerText, { marginTop: 5 }]}>
            <Text style={pdfStyles.headerTextBold}>Recenseur :</Text>{' '}
            {user.prenom?.toUpperCase()} {user.nom?.toUpperCase()}
          </Text>
        )}
        {organizationNumCertification && (
          <Text style={pdfStyles.headerText}>
            Certification Dendromap : {organizationNumCertification}
          </Text>
        )}
      </View>
    </View>
  );
};
